import React from 'react';

import { Tooltip, TooltipProps } from '@mui/material';
import { Info } from 'phosphor-react';

export const HelpTooltip = ({
  tooltipSz = 12,
  ...props
}: Omit<TooltipProps, 'children'> & { tooltipSz?: number }) => (
  <Tooltip {...props}>
    <Info size={tooltipSz} />
  </Tooltip>
);
